import PropTypes from 'prop-types';

import { ROUTE_SCANBAT } from '@/common/constants';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';
import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import {
  WarehouseDefaultProps,
  WarehousePropTypes,
} from '@/common/proptypes/Common/Warehouse/Warehouse.proptypes';

export const HeaderDefaultProps = {
  ...ClassNameDefaultProps,
  ...DisabledDefaultProps,
  company: null,
  link: ROUTE_SCANBAT,
  onRemoveWarehouse: () => {},
  warehouse: { ...WarehouseDefaultProps },
};

export const HeaderPropTypes = {
  ...ClassNamePropTypes,
  ...DisabledPropTypes,
  company: PropTypes.string,
  link: PropTypes.string,
  onRemoveWarehouse: PropTypes.func,
  warehouse: PropTypes.shape({ ...WarehousePropTypes }),
};
